module.exports = __webpack_public_path__ + "img/efe6abb.svg";